import { AccountNotFoundError } from "../../../errors/account.js";
import { ChainNotFoundError } from "../../../errors/client.js";
import { signUserOperation } from "../signUserOperation.js";
export async function _sendUserOperation(client, args) {
    const { account = client.account, uoStruct, context, overrides } = args;
    if (!account) {
        throw new AccountNotFoundError();
    }
    if (!client.chain) {
        throw new ChainNotFoundError();
    }
    const entryPoint = account.getEntryPoint();
    const request = await signUserOperation(client, {
        uoStruct,
        account,
        context,
        overrides,
    });
    return {
        hash: await client.sendRawUserOperation(request, entryPoint.address),
        request,
    };
}
//# sourceMappingURL=sendUserOperation.js.map